/**
 * 浮動（フローティング）ボタンの表示制御クラス
 * - スクロール位置に応じて表示/非表示
 * - フッターと重なる場合は position を absolute に切り替え
 */
export class Floating {
    constructor() {
        this.$floating = $('.js-floating'); // フローティングボタン
        this.$footer = $('.l-footer');      // フッター要素
        this._init();
    }

    /**
     * 初期設定
     * - イベントをバインド
     */
    _init() {
        this._bindEvents();
    }

    /**
     * スクロールイベントのバインド
     * @private
     */
    _bindEvents() {
        $(window).on('scroll', () => this._footerSwitch());
    }

    /**
     * ボタンの位置と表示状態を更新
     * - フッターと重なる場合は absolute に切り替え
     * - スクロール量でフェードイン/アウト
     * @private
     */
    _footerSwitch() {
        const footerOffsetTop = this.$footer.offset().top;
        const windowScrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        const isButtonNearFooter = footerOffsetTop - windowScrollTop <= windowHeight;

        this.$floating.css('position', isButtonNearFooter ? 'absolute' : 'fixed');
        this.$floating.toggleClass('change', isButtonNearFooter);

        const isScrolledPastThreshold = windowScrollTop >= 200;
        this.$floating.stop().animate({ opacity: isScrolledPastThreshold ? 1 : 0 }, {
            duration: 'fast',
            easing: 'linear',
            queue: false
        });
    }
}

// シングルトンとしてエクスポート
export default new Floating();
